const shareButtons = {
  en: {
    shareButtons: {
      defaultTitle: "EReMS Cameroon - Election Results",
      defaultText: "Check out the live election results on EReMS Cameroon!",
      linkCopied: "Link copied to clipboard!",
      copyFailed: "Failed to copy link",
      shareFailed: "Failed to share",
      share: "Share",
      copied: "Copied!",
      copyLink: "Copy Link",
      moreOptions: "More Options...",
      shareLabel: "Share:"
    }
  },
  fr: {
    shareButtons: {
      defaultTitle: "EReMS Cameroon - Résultats des élections",
      defaultText: "Découvrez les résultats des élections en direct sur EReMS Cameroon !",
      linkCopied: "Lien copié dans le presse-papiers !",
      copyFailed: "Échec de la copie du lien",
      shareFailed: "Échec du partage",
      share: "Partager",
      copied: "Copié !",
      copyLink: "Copier le lien",
      moreOptions: "Plus d'options...",
      shareLabel: "Partager :"
    }
  }
};

export default shareButtons;
